module.exports = "/_next/static/images/arkansas-b175808ca9dbece999a01cfa89b67286.svg";